import {
  Avatar, Card, Container, makeStyles, Typography,
} from '@material-ui/core';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import PropTypes from 'prop-types';

import kami from '../../../assets/img/Kami-message.png';

const useStyles = makeStyles((theme) => ({
  generalContainer: {
    display: 'block',
    marginTop: '20px',
  },
  botContainer: {
    display: 'flex',
    paddingLeft: '0px',
  },
  messageCardBot: {
    background: theme.palette.primary.light,
    color: theme.palette.text.default,
    borderRadius: '8px',
    marginRight: 'auto',
    width: 'max-content',
    maxWidth: '50%',
    padding: '7px',
  },
  messageCardUser: {
    background: theme.palette.text.default,
    color: theme.palette.text.primary,
    borderRadius: '8px',
    marginLeft: 'auto',
    minWidth: '8%',
    width: 'max-content',
    padding: '7px',
  },
  messageText: {
    fontSize: '11.5px',
    fontFamily: 'Raleway',
  },
  hourBot: {
    color: theme.palette.text.default,
    fontSize: '10px',
    fontFamily: 'Raleway',
    padding: '6px',
    marginBottom: '16px',
  },
  hourUser: {
    color: theme.palette.text.default,
    fontSize: '10px',
    fontFamily: 'Raleway',
    padding: '6px',
    textAlign: 'end',
    marginBottom: '16px',
  },
  doneIcon: {
    paddingLeft: '4px',
  },
}));

function MessageFormat({ message }) {
  const classes = useStyles();

  return (

    <Container className={classes.generalContainer}>
      {
        message.Kami
          ? (
            <Container className={classes.botContainer}>
              <Avatar alt="Kami" src={kami} />
              <Container>
                {
                  message.Kami.map((mk) => (
                    <Container key={mk.id}>
                      <Card
                        className={classes.messageCardBot}
                      >
                        <Typography className={classes.messageText}>
                          {mk.text}
                        </Typography>
                        {
                          mk.alternatives
                          && mk.alternatives.map((alternative) => (
                            <Typography
                              className={classes.messageText}
                              key={alternative}
                            >
                              {alternative}
                            </Typography>
                          ))
                        }
                      </Card>
                      <Typography className={classes.hourBot}>
                        {mk.createdAt?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </Typography>
                    </Container>
                  ))
                }
              </Container>
            </Container>
          )
          : (
            <Container>
              <Container className={classes.userContainer}>

                {
                  message.User.map((mu) => (
                    <Container key={mu.id}>
                      <Card
                        className={classes.messageCardUser}
                      >
                        <Typography className={classes.messageText}>
                          {mu.text}
                        </Typography>
                      </Card>
                      <Typography className={classes.hourUser}>
                        {mu.createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        <DoneAllIcon style={{ fontSize: '10px' }} className={classes.doneIcon} />
                      </Typography>
                    </Container>
                  ))
                }
              </Container>
            </Container>
          )
      }
    </Container>
  );
}

export default MessageFormat;
MessageFormat.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.object,
  ]).isRequired,
};
